module.exports = __webpack_public_path__ + "static/no-image-d2607fa292e5f42c75e35a82e1998e18.png";